// ===================================================
// SEMANTIC VERB-ELEMENT MAPPINGS
// Mapeos detallados verbo→elementos por contexto
// Evita combinaciones sin sentido como "inflar galletas"
// ===================================================

/**
 * Para cada contexto, define qué verbos pueden usarse con qué elementos
 * Estructura: { verbo: [elementos_compatibles] }
 */
const SEMANTIC_MAPPINGS = {
    // 1. CUMPLEAÑOS
    cumpleanos: {
        'invitar': ['invitados', 'amigos', 'primos', 'niños'],
        'llegar': ['invitados', 'amigos', 'primos'],
        'recibir': ['regalos', 'invitaciones', 'juguetes', 'fotos'],
        'soplar': ['velas', 'pitos'],
        'abrir': ['regalos', 'juguetes', 'sobres'],
        'comer': ['trozos de tarta', 'caramelos', 'sándwiches', 'bolsas de chuches'],
        'repartir': ['trozos de tarta', 'caramelos', 'bolsas de chuches', 'gorros de fiesta', 'platos de cartón', 'vasos de colores', 'servilletas', 'pajitas', 'tazas', 'invitaciones', 'pitos'],
        'inflar': ['globos'],
        'apagar': ['velas', 'luces'],
        'decorar': ['globos', 'serpentinas', 'sillas', 'mesa'],
        'traer': ['regalos', 'refrescos', 'sándwiches', 'hielo', 'juguetes'],
        'comprar': ['regalos', 'globos', 'refrescos', 'caramelos', 'velas', 'platos de cartón', 'vasos de colores', 'piñatas', 'coronas'],
        'faltar': ['invitados', 'vasos de colores', 'platos de cartón', 'tenedores de plástico', 'sillas', 'servilletas'],
        'sobrar': ['caramelos', 'trozos de tarta', 'refrescos', 'sándwiches', 'vasos de colores'],
        'compartir': ['trozos de tarta', 'caramelos', 'juguetes'],
        'sentar': ['invitados', 'amigos', 'primos', 'niños'],
        'cantar': ['invitados', 'amigos'],
        'desenvolver': ['regalos'],
        'poner': ['mesa', 'luces', 'coronas', 'gorros de fiesta', 'servilletas'],
        'romper': ['piñatas', 'globos'],
        'perder': ['juguetes', 'globos'],
        'elegir': ['regalos', 'canciones', 'juegos'],
        'explotar': ['globos']
    },

    // 2. FERIA
    feria: {
        'ganar': ['tickets', 'peluches', 'premios', 'patitos de plástico', 'gorras', 'pulseras'],
        'gastar': ['tickets', 'monedas de euro', 'fichas'],
        'subir': ['vueltas de noria', 'atracciones', 'coches de choque'],
        'comprar': ['algodones de azúcar', 'piruletas', 'palomitas', 'helados', 'fichas', 'tickets', 'globos'],
        'lanzar': ['dardos', 'botes', 'anillas', 'pelotas'],
        'encestar': ['cestas de baloncesto', 'pelotas'],
        'pescar': ['patitos de plástico'],
        'esperar': ['personas en fila', 'amigos', 'turno'],
        'canjear': ['tickets', 'premios'],
        'montar': ['coches de choque', 'atracciones', 'noria', 'caballitos'],
        'perder': ['tickets', 'fichas', 'monedas de euro', 'gorras'],
        'pedir': ['premios', 'peluches', 'algodones de azúcar'],
        'contar': ['tickets', 'premios', 'monedas de euro', 'fichas', 'patitos de plástico', 'luces', 'banderines'],
        'pagar': ['monedas de euro', 'atracciones', 'comida'],
        'participar': ['rifas', 'juegos', 'sorteos'],
        'premiar': ['peluches', 'premios', 'juguetes'],
        'recibir': ['premios', 'peluches', 'tickets'],
        'elegir': ['premios', 'atracciones'],
        'encontrar': ['amigos', 'tickets', 'monedas'],
        'entrar': ['atracciones', 'caseta de terror']
    },

    // 3. CINE
    cine: {
        'entrar': ['personas en la fila', 'niños', 'adultos', 'amigos'],
        'salir': ['personas', 'niños', 'adultos'],
        'sentarse': ['butacas', 'sillas'],
        'elegir': ['entradas', 'butacas', 'películas'],
        'comprar': ['entradas', 'bolsas de palomitas', 'refrescos', 'chocolatinas', 'tickets', 'caramelos', 'botellas de agua'],
        'compartir': ['bolsas de palomitas', 'caramelos', 'chocolatinas'],
        'pagar': ['entradas', 'comida', 'tickets'],
        'ocupar': ['butacas', 'sitios'],
        'reservar': ['butacas', 'entradas'],
        'ver': ['carteles', 'posters', 'películas', 'trailers', 'pantallas'],
        'esperar': ['personas en la fila', 'amigos'],
        'contar': ['butacas', 'entradas', 'filas', 'personas'],
        'comer': ['bolsas de palomitas', 'chocolatinas', 'caramelos'],
        'beber': ['refrescos', 'agua'],
        'recoger': ['entradas', 'tickets', 'basura', 'gafas 3D'],
        'buscar': ['butacas', 'sitios', 'salida'],
        'traer': ['abrigos', 'bolsas', 'entradas'],
        'llenar': ['salas', 'butacas'],
        'tirar': ['papeles', 'botellas vacías', 'cajas de palomitas'],
        'mirar': ['carteleras', 'horarios', 'pantallas'],
        'iluminar': ['pantallas', 'pasillos'],
        'apagar': ['luces', 'móviles']
    },

    // 4. VIAJE ABUELOS
    viaje_abuelos: {
        'viajar': ['kilómetros', 'días', 'horas'],
        'conducir': ['kilómetros', 'horas'],
        'parar': ['pueblos', 'gasolineras'],
        'caminar': ['kilómetros', 'senderos'],
        'visitar': ['monumentos', 'pueblos', 'parques', 'museos', 'primos'],
        'descubrir': ['monumentos', 'pueblos', 'paisajes', 'rincones'],
        'merendar': ['bocadillos', 'frutas', 'helados', 'galletas', 'manzanas'],
        'recordar': ['fotos', 'momentos', 'historias'],
        'subir': ['maletas', 'bolsas'],
        'bajar': ['maletas', 'bolsas'],
        'guardar': ['fotos', 'recuerdos', 'postales', 'mapas', 'tickets', 'juguetes', 'ropa', 'zapatos', 'cargadores'],
        'sacar': ['fotos', 'billetes', 'mapas'],
        'regalar': ['recuerdos', 'postales', 'imanes'],
        'fotografiar': ['monumentos', 'paisajes', 'pueblos'],
        'comprar': ['recuerdos', 'postales', 'helados', 'imanes', 'pegatinas', 'regalos', 'comida'],
        'buscar': ['monumentos', 'mapas', 'hoteles', 'restaurantes', 'llaves'],
        'observar': ['monumentos', 'paisajes'],
        'llegar': ['pueblos', 'destinos'],
        'contar': ['kilómetros', 'días', 'maletas', 'monedas', 'ovejas'],
        'perder': ['mapas', 'llaves', 'gorras'],
        'gastar': ['dinero', 'gasolina'],
        'olvidar': ['maletas', 'cargadores', 'paraguas', 'abrigos'],
        'dejar': ['maletas', 'llaves'],
        'comer': ['bocadillos', 'helados', 'platos típicos'],
        'dormir': ['horas', 'siestas']
    },

    // 5. CIRCO
    circo: {
        'actuar': ['payasos', 'trapecistas', 'malabaristas', 'magos', 'elefantes', 'tigres'],
        'saltar': ['payasos', 'trapecistas', 'tigres', 'leones'],
        'equilibrar': ['pelotas', 'aros', 'platos'],
        'lanzar': ['pelotas', 'aros', 'mazas', 'cuchillos'],
        'aplaudir': ['payasos', 'trapecistas', 'malabaristas', 'niños', 'público'],
        'aparecer': ['payasos', 'tigres', 'elefantes', 'conejos', 'palomas'],
        'desaparecer': ['payasos', 'conejos', 'magos'],
        'entrenar': ['tigres', 'elefantes', 'leones', 'perros'],
        'desfilar': ['elefantes', 'artistas', 'caballos'],
        'cuidar': ['tigres', 'elefantes', 'animales'],
        'montar': ['monociclos', 'caballos', 'elefantes'],
        'vender': ['entradas', 'palomitas', 'globos', 'juguetes', 'chuches'],
        'comprar': ['entradas', 'palomitas', 'algodones', 'refrescos', 'fotos', 'piruletas'],
        'entrar': ['payasos', 'tigres', 'elefantes', 'público'],
        'salir': ['payasos', 'malabaristas', 'público'],
        'reír': ['niños', 'payasos', 'público'],
        'asombrar': ['niños', 'público'],
        'limpiar': ['pista', 'jaulas', 'gradas'],
        'silbar': ['payasos', 'domadores'],
        'saludar': ['artistas', 'payasos'],
        'inflar': ['globos'],
        'traer': ['aros', 'pelotas', 'sillas']
    },

    // 6. RESTAURANTE
    restaurante: {
        'pedir': ['platos', 'postres', 'bebidas', 'hamburguesas', 'pizzas', 'helados', 'menús', 'pan', 'agua'],
        'cocinar': ['platos', 'hamburguesas', 'pizzas', 'pescado', 'pasta'],
        'servir': ['platos', 'postres', 'bebidas', 'cafés', 'mesas', 'clientes'],
        'comer': ['platos', 'hamburguesas', 'pizzas', 'helados', 'postres', 'pan'],
        'pagar': ['billetes de euro', 'monedas', 'cuenta', 'propina'],
        'reservar': ['mesas', 'sillas'],
        'elegir': ['platos', 'postres', 'menús', 'vino'],
        'traer': ['platos', 'bebidas', 'cubiertos', 'cuenta', 'pan', 'servilletas', 'jarras de agua', 'vasos'],
        'retirar': ['platos', 'vasos', 'cubiertos', 'servilletas', 'manteles'],
        'probar': ['postres', 'platos', 'sopa'],
        'beber': ['bebidas', 'jarras de agua', 'refrescos', 'zumos'],
        'sentar': ['clientes', 'mesas', 'niños'],
        'esperar': ['clientes', 'mesa', 'comida'],
        'limpiar': ['mesas', 'platos', 'vasos', 'suelo'],
        'sumar': ['cuenta', 'precios'],
        'dividir': ['cuenta'],
        'dejar': ['propina', 'platos', 'servilletas'],
        'gustar': ['platos', 'postres'],
        'anotar': ['pedidos', 'reservas'],
        'saludar': ['camareros', 'clientes'],
        'quitar': ['platos', 'migas'],
        'romper': ['platos', 'vasos', 'copas'],
        'llevarse': ['sobras', 'comida']
    },

    // 7. DISFRACES
    disfraces: {
        'disfrazar': ['niños', 'amigos', 'muñecos'],
        'maquillar': ['pinturas de cara', 'niños', 'amigos', 'caras'],
        'poner': ['máscaras', 'capas', 'pelucas', 'sombreros', 'guantes', 'zapatos', 'alas', 'coronas', 'antifaces', 'bigotes postizos', 'diademas'],
        'quitar': ['máscaras', 'capas', 'pelucas', 'maquillaje'],
        'combinar': ['accesorios', 'colores', 'telas'],
        'prestar': ['capas', 'pelucas', 'máscaras', 'sombreros', 'varitas mágicas'],
        'coser': ['capas', 'telas', 'disfraces', 'botones', 'lentejuelas'],
        'comprar': ['máscaras', 'capas', 'pelucas', 'varitas mágicas', 'pinturas', 'telas', 'alas', 'coronas', 'purpurina'],
        'buscar': ['máscaras', 'sombreros', 'zapatos', 'accesorios'],
        'encontrar': ['máscaras', 'capas', 'pelucas', 'tesoros'],
        'repartir': ['máscaras', 'varitas mágicas', 'confitis', 'caramelos'],
        'ganar': ['concursos', 'premios'],
        'elegir': ['disfraces', 'máscaras', 'personajes'],
        'recortar': ['máscaras', 'telas', 'patrones'],
        'pegar': ['lentejuelas', 'purpurina', 'plumas', 'parches'],
        'bailar': ['niños', 'amigos', 'disfraces'],
        'asustar': ['amigos', 'vecinos'],
        'celebrar': ['fiestas', 'carnaval'],
        'cambiar': ['disfraces', 'accesorios'],
        'lucir': ['disfraces', 'trajes'],
        'regalar': ['disfraces', 'accesorios'],
        'guardar': ['disfraces', 'máscaras', 'cajas'],
        'esconder': ['máscaras', 'tesoros']
    },

    // 8. GRANJA
    granja: {
        'alimentar': ['vacas', 'cerdos', 'gallinas', 'ovejas', 'caballos', 'patos', 'gorriones'],
        'ordeñar': ['vacas', 'ovejas'],
        'nacer': ['pollitos', 'cerditos', 'terneros'],
        'recoger': ['huevos', 'manzanas', 'zanahorias', 'herramientas'],
        'limpiar': ['establos', 'comederos', 'tractores', 'botas'],
        'cuidar': ['vacas', 'cerdos', 'gallinas', 'ovejas', 'caballos', 'perros pastores', 'gatos de granja'],
        'pastar': ['ovejas', 'vacas', 'caballos'],
        'correr': ['caballos', 'cerdos', 'perros', 'niños'],
        'saltar': ['ovejas', 'caballos', 'vallas'],
        'contar': ['vacas', 'gallinas', 'ovejas', 'huevos', 'cerdos', 'patos', 'caballos'],
        'agrupar': ['gallinas', 'ovejas', 'vacas'],
        'vender': ['huevos', 'leche', 'lana', 'queso'],
        'comprar': ['tractores', 'pacas de paja', 'sacos de pienso', 'herramientas', 'semillas'],
        'vigilar': ['ovejas', 'vacas', 'gallinas'],
        'cargar': ['pacas de paja', 'sacos de pienso', 'cajas', 'remolques'],
        'dormir': ['animales', 'granjeros'],
        'entrar': ['animales', 'establos'],
        'salir': ['animales', 'campo'],
        'sembrar': ['trigo', 'maíz', 'zanahorias'],
        'pesar': ['sacos', 'cerdos', 'cajas'],
        'traer': ['agua', 'comida', 'paja'],
        'rescatar': ['pollitos', 'gatos'],
        'aparecer': ['ratones', 'zorros'],
        'escapar': ['gallinas', 'cerdos'],
        'regalar': ['huevos', 'verduras'],
        'esconderse': ['gatos', 'ratones']
    },

    // 9. HUERTO
    huerto: {
        'plantar': ['tomates', 'lechugas', 'zanahorias', 'semillas', 'pimientos', 'patatas', 'fresas', 'calabazas'],
        'regar': ['tomates', 'lechugas', 'flores de calabaza', 'plantas', 'semillas', 'huerto'],
        'cavar': ['surcos', 'agujeros'],
        'cosechar': ['tomates', 'lechugas', 'zanahorias', 'pimientos', 'patatas', 'calabazas', 'fresas'],
        'crecer': ['tomates', 'lechugas', 'flores', 'plantas'],
        'podar': ['tomates', 'plantas', 'ramas'],
        'quitar': ['gusanos', 'malas hierbas', 'hojas secas', 'piedras'],
        'medir': ['surcos de tierra', 'plantas', 'hileras'],
        'repartir': ['tomates', 'lechugas', 'zanahorias', 'verduras'],
        'recolectar': ['tomates', 'lechugas', 'zanahorias', 'frutas', 'verduras'],
        'limpiar': ['herramientas', 'macetas', 'botas', 'guantes'],
        'contar': ['tomates', 'zanahorias', 'semillas', 'macetas', 'calabazas', 'surcos'],
        'cargar': ['cestas', 'sacos', 'carretillas'],
        'clasificar': ['tomates', 'patatas', 'pimientos', 'semillas'],
        'florecer': ['plantas', 'flores'],
        'pesar': ['cestas', 'tomates', 'patatas', 'calabazas'],
        'enterrar': ['semillas', 'abono'],
        'brotar': ['semillas', 'plantas'],
        'observar': ['insectos', 'plantas', 'crecimiento'],
        'abonar': ['tierra', 'plantas'],
        'traer': ['agua', 'herramientas', 'semillas'],
        'comprar': ['semillas', 'herramientas', 'abono', 'plantas'],
        'encontrar': ['gusanos', 'caracoles', 'piedras'],
        'arrancar': ['hierbajos', 'zanahorias'],
        'regalar': ['verduras', 'tomates'],
        'secarse': ['plantas', 'hojas']
    },

    // 10. PARQUE
    parque: {
        'jugar': ['niños', 'niñas', 'perros', 'amigos', 'pelota'],
        'correr': ['niños', 'niñas', 'perros'],
        'saltar': ['niños', 'niñas', 'perros', 'charcos', 'a la cuerda'],
        'columpiar': ['niños', 'niñas'],
        'deslizar': ['toboganes'],
        'subir': ['toboganes', 'columpios', 'árboles'],
        'bajar': ['toboganes', 'árboles'],
        'compartir': ['pelotas', 'patinetes', 'juguetes', 'bocadillos', 'cubos'],
        'merendar': ['bocadillos', 'fruta', 'galletas'],
        'esperar': ['niños', 'niñas', 'turno'],
        'pasear': ['perros', 'bebés'],
        'encontrar': ['pelotas', 'palos', 'piedras', 'hojas secas', 'flores', 'móviles'],
        'lanzar': ['pelotas', 'palos', 'frisbee'],
        'trepar': ['árboles', 'cuerdas'],
        'vigilar': ['niños', 'perros'],
        'contar': ['columpios', 'bancos', 'niños', 'árboles', 'farolas', 'palomas'],
        'esconderse': ['niños', 'niñas', 'detrás de los árboles'],
        'llegar': ['niños', 'amigos'],
        'traer': ['juguetes', 'pelotas', 'bicicletas', 'patinetes', 'meriendas'],
        'tirar': ['papeles', 'basura', 'piedras'],
        'elegir': ['juegos', 'columpios'],
        'perseguir': ['palomas', 'amigos'],
        'silbar': ['pájaros', 'niños']
    },

    // 11. PLAYA
    playa: {
        'bañar': ['niños', 'niñas', 'muñecas'],
        'nadar': ['niños', 'peces', 'personas'],
        'bucear': ['niños', 'peces'],
        'construir': ['castillos de arena', 'botes'],
        'recoger': ['conchas', 'piedras', 'estrellas de mar', 'cangrejos', 'toallas', 'juguetes'],
        'saltar': ['olas', 'rocas'],
        'buscar': ['conchas', 'cangrejos', 'estrellas de mar', 'peces'],
        'encontrar': ['conchas', 'piedras', 'cangrejos', 'estrellas de mar', 'tesoros'],
        'poner': ['sombrillas', 'toallas', 'cremas', 'hamacas', 'gorras'],
        'secar': ['toallas', 'bañadores', 'pelo'],
        'jugar': ['pelotas de playa', 'palas', 'cubos', 'conchas'],
        'volar': ['cometas'],
        'enterrar': ['castillos de arena', 'pies', 'juguetes'],
        'flotar': ['flotadores', 'barcos', 'manguitos'],
        'untar': ['cremas'],
        'inflar': ['flotadores', 'pelotas de playa', 'manguitos', 'colchonetas'],
        'mojar': ['toallas', 'pies', 'arena'],
        'vigilar': ['niños', 'bolsas'],
        'caminar': ['playa', 'orilla'],
        'remar': ['barcos', 'botes'],
        'hacer': ['castillos de arena', 'agujeros'],
        'pescar': ['peces', 'cangrejos'],
        'devolver al mar': ['peces', 'estrellas de mar', 'cangrejos'],
        'traer': ['toallas', 'sombrillas', 'bocadillos', 'cubos'],
        'comprar': ['helados', 'refrescos', 'cremas', 'gafas de sol'],
        'contar': ['conchas', 'olas', 'barcos', 'gaviotas']
    },

    // 12. CENTRO ANIMALES
    centro_animales: {
        'curar': ['animales heridos', 'tortugas', 'pájaros', 'búhos', 'peces'],
        'rescatar': ['animales heridos', 'tortugas', 'pájaros'],
        'alimentar': ['animales heridos', 'tortugas', 'pájaros', 'búhos'],
        'pesar': ['animales heridos', 'tortugas', 'búhos'],
        'observar': ['animales heridos', 'nidos artificiales'],
        'liberar': ['animales heridos', 'tortugas', 'pájaros'],
        'limpiar': ['jaulas de transporte', 'cuencos de comida', 'bañeras', 'heridas'],
        'vendar': ['animales heridos', 'patas', 'alas'],
        'vacunar': ['animales heridos'],
        'cuidar': ['animales heridos', 'crías'],
        'recibir': ['animales heridos', 'medicinas', 'donaciones'],
        'rehabilitar': ['animales heridos', 'pájaros'],
        'anotar': ['expedientes médicos', 'datos'],
        'soltar': ['animales heridos', 'pájaros'],
        'proteger': ['animales heridos', 'nidos artificiales'],
        'sanar': ['animales heridos'],
        'traer': ['medicinas', 'cuencos de comida', 'mantas', 'toallas', 'comida'],
        'medir': ['animales heridos', 'alas'],
        'buscar': ['animales heridos', 'medicinas'],
        'encontrar': ['animales heridos', 'nidos'],
        'llegar': ['animales heridos', 'veterinarios'],
        'volar': ['pájaros', 'búhos'],
        'entrar': ['animales heridos', 'jaulas']
    },

    // 13. CONCURSO CANINO
    concurso_canino: {
        'desfilar': ['perros', 'razas'],
        'saltar': ['perros', 'obstáculos', 'aros'],
        'correr': ['perros', 'dueños'],
        'obedecer': ['perros', 'órdenes'],
        'peinar': ['perros', 'razas'],
        'juzgar': ['jueces', 'perros'],
        'ganar': ['trofeos', 'medallas', 'escarapelas', 'puntos', 'premios'],
        'participar': ['perros', 'razas', 'dueños'],
        'premiar': ['trofeos', 'medallas', 'perros'],
        'ladrar': ['perros'],
        'esperar': ['perros', 'dueños', 'turno'],
        'caminar': ['perros', 'pasarelas'],
        'sentarse': ['perros'],
        'calificar': ['puntos', 'perros'],
        'seguir': ['perros', 'dueños'],
        'competir': ['perros', 'razas'],
        'entrenar': ['perros'],
        'tumbarse': ['perros'],
        'morder': ['juguetes', 'huesos'],
        'guiar': ['perros'],
        'recibir': ['premios', 'aplausos', 'sacos de comida'],
        'poner': ['correas', 'lazos', 'pañuelos', 'dorsales'],
        'traer': ['perros', 'juguetes', 'agua', 'mantas']
    },

    // 14. EXPOSICIÓN PLANTAS
    exposicion_plantas: {
        'exponer': ['orquídeas', 'rosas', 'tulipanes', 'cactus', 'margaritas'],
        'admirar': ['orquídeas', 'rosas', 'tulipanes', 'ramos'],
        'oler': ['rosas', 'flores', 'tulipanes'],
        'clasificar': ['orquídeas', 'rosas', 'tulipanes', 'cactus'],
        'comprar': ['macetas', 'rosas', 'tulipanes', 'ramos', 'semillas', 'abonos', 'herramientas de jardín'],
        'regar': ['orquídeas', 'rosas', 'macetas'],
        'colocar': ['macetas', 'ramos', 'etiquetas de precio'],
        'etiquetar': ['macetas', 'plantas'],
        'ganar': ['cintas de premio', 'concursos'],
        'fotografiar': ['orquídeas', 'rosas', 'flores'],
        'explicar': ['visitantes', 'cuidados'],
        'elegir': ['rosas', 'tulipanes', 'ramos', 'macetas'],
        'podar': ['rosas', 'hojas', 'tallos'],
        'decorar': ['ramos', 'stands'],
        'presentar': ['orquídeas', 'rosas', 'cactus'],
        'vender': ['macetas', 'ramos', 'semillas'],
        'crecer': ['plantas', 'flores'],
        'brotar': ['semillas', 'bulbos'],
        'marchitar': ['flores', 'pétalos'],
        'regalar': ['flores', 'ramos', 'semillas'],
        'plantar': ['bulbos', 'semillas'],
        'traer': ['macetas', 'agua', 'tijeras'],
        'añadir': ['abono', 'agua'],
        'llevarse': ['macetas', 'ramos', 'folletos']
    },

    // 15. ACUARIO
    acuario: {
        'nadar': ['peces', 'tiburones', 'rayas', 'tortugas', 'focas', 'pingüinos'],
        'bucear': ['buzos'],
        'alimentar': ['peces', 'tiburones', 'pingüinos', 'rayas', 'tortugas'],
        'mirar': ['peces', 'medusas', 'estrellas de mar', 'tiburones', 'tanques de agua'],
        'contar': ['peces', 'tiburones', 'medusas', 'caballitos de mar', 'tortugas', 'pingüinos'],
        'limpiar': ['tanques de agua', 'cristales', 'filtros'],
        'filtrar': ['tanques de agua', 'agua'],
        'iluminar': ['tanques de agua', 'medusas'],
        'sumergir': ['buzos', 'cámaras'],
        'descubrir': ['peces', 'corales', 'tesoros'],
        'flotar': ['medusas', 'algas'],
        'ubicar': ['peces', 'corales', 'rocas'],
        'cuidar': ['peces', 'tiburones', 'animales'],
        'observar': ['peces', 'medusas', 'caballitos de mar'],
        'grabar': ['videos', 'peces'],
        'seguir': ['peces', 'rutas'],
        'esconderse': ['peces', 'pulpos', 'cangrejos'],
        'respirar': ['buzos', 'peces'],
        'marcar': ['territorio'],
        'pintar': ['cuadros'],
        'dibujar': ['peces'],
        'nadar hacia': ['rocas', 'superficie'],
        'meter': ['peces', 'comida'],
        'nacer': ['peces', 'crías'],
        'soltar': ['peces'],
        'encontrar': ['peces', 'estrellas de mar'],
        'sacar': ['fotos', 'entradas'],
        'nadar lejos': ['tiburones'],
        'pescar': ['juguetes']
    },

    // 16. EXCURSIÓN MONTE
    excursion_monte: {
        'caminar': ['kilómetros', 'senderos', 'rutas'],
        'subir': ['montañas', 'colinas', 'rocas', 'árboles'],
        'bajar': ['senderos', 'montañas', 'ríos'],
        'merendar': ['bocadillos', 'fruta', 'frutos secos'],
        'observar': ['pájaros', 'insectos', 'ardillas', 'nidos', 'paisajes'],
        'encontrar': ['piñas', 'piedras', 'flores silvestres', 'setas', 'huellas de animales', 'bellotas', 'hormigas'],
        'fotografiar': ['pájaros', 'flores silvestres', 'paisajes', 'amigos', 'animales'],
        'descansar': ['excursionistas', 'amigos'],
        'seguir': ['senderos', 'huellas', 'mapas', 'señales'],
        'recolectar': ['piñas', 'piedras', 'hojas', 'setas'],
        'señalar': ['señales', 'picos', 'nubes'],
        'saltar': ['ríos', 'puentes', 'rocas', 'charcos'],
        'cruzar': ['ríos', 'puentes', 'caminos'],
        'trepar': ['montañas', 'rocas', 'árboles'],
        'guardar': ['mochilas', 'mapas', 'brújulas', 'cantimploras', 'basura'],
        'buscar': ['senderos', 'refugios', 'cuevas'],
        'orientar': ['mapas', 'brújulas'],
        'escuchar': ['pájaros', 'viento', 'ríos'],
        'pisar': ['hojas', 'charcos', 'barro'],
        'refrescar': ['pies', 'caras'],
        'recoger': ['basura', 'mochilas'],
        'llegar': ['cima', 'meta', 'refugio'],
        'ver': ['animales', 'paisajes'],
        'traer': ['mochilas', 'bocadillos', 'agua']
    },

    // 17. MASCOTAS
    mascotas: {
        'pasear': ['perros'],
        'alimentar': ['perros', 'gatos', 'hámsteres', 'peces', 'pájaros'],
        'bañar': ['perros', 'gatos'],
        'jugar': ['perros', 'gatos', 'hámsteres'],
        'cepillar': ['perros', 'gatos'],
        'acariciar': ['perros', 'gatos', 'hámsteres'],
        'educar': ['perros'],
        'recoger': ['juguetes', 'cacas', 'platos'],
        'comprar': ['sacos de pienso', 'juguetes', 'collares', 'camas', 'arenas'],
        'visitar': ['veterinarios'],
        'vigilar': ['perros', 'gatos', 'hámsteres'],
        'llamar': ['perros', 'gatos'],
        'esconder': ['juguetes', 'huesos'],
        'correr': ['perros', 'gatos'],
        'saltar': ['perros', 'gatos'],
        'ladrar': ['perros'],
        'maullar': ['gatos'],
        'dormir': ['perros', 'gatos'],
        'querer': ['perros', 'gatos', 'mascotas'],
        'morder': ['huesos', 'juguetes'],
        'regalar': ['juguetes', 'premios'],
        'traer': ['pelotas', 'palos'],
        'encontrar': ['juguetes', 'mascotas'],
        'adoptar': ['perros', 'gatos'],
        'poner': ['collares', 'vacunas', 'comida'],
        'romper': ['juguetes', 'camas'],
        'perder': ['pelotas', 'juguetes'],
        'tirar': ['pelotas']
    },

    // 18. COCINA
    cocina: {
        'cocinar': ['galletas', 'magdalenas', 'recetas', 'platos'],
        'mezclar': ['ingredientes', 'masas', 'harinas'],
        'batir': ['huevos', 'mezclas', 'masas'],
        'hornear': ['galletas', 'magdalenas', 'pasteles', 'panes'],
        'pesar': ['ingredientes', 'harinas', 'azúcar'],
        'medir': ['vasos de leche', 'cucharadas de azúcar', 'agua', 'aceite'],
        'cortar': ['manzanas', 'frutas', 'verduras', 'quesos', 'pan'],
        'pelar': ['manzanas', 'frutas', 'patatas', 'zanahorias'],
        'lavar': ['frutas', 'verduras', 'manos', 'platos'],
        'servir': ['galletas', 'magdalenas', 'yogures', 'tazas'],
        'calentar': ['leche', 'agua', 'comida'],
        'enfriar': ['galletas', 'pasteles', 'gelatinas'],
        'repartir': ['galletas', 'magdalenas', 'platos'],
        'probar': ['galletas', 'masas', 'salsas'],
        'recoger': ['platos', 'cubiertos', 'mesa', 'cocina'],
        'freír': ['huevos', 'patatas'],
        'encender': ['horno', 'fuegos'],
        'apagar': ['horno', 'fuegos'],
        'untar': ['mantequilla', 'mermelada'],
        'vaciar': ['botes', 'lavavajillas'],
        'poner': ['mesa', 'ingredientes'],
        'traer': ['ingredientes', 'compra'],
        'comprar': ['ingredientes', 'huevos', 'leche', 'frutas'],
        'añadir': ['sal', 'azúcar', 'especias'],
        'llenar': ['vasos', 'botes', 'ollas'],
        'romper': ['huevos'],
        'quitar': ['cáscaras'],
        'gastar': ['ingredientes'],
        'tirar': ['basura', 'cáscaras']
    },

    // 19. JUGUETES
    juguetes: {
        'jugar': ['coches', 'muñecas', 'peluches', 'bloques', 'juegos de mesa', 'canicas', 'robots'],
        'ordenar': ['juguetes', 'bloques', 'libros', 'peluches', 'estanterías'],
        'guardar': ['juguetes', 'coches', 'muñecas', 'piezas', 'cajas'],
        'prestar': ['juguetes', 'coches', 'juegos', 'libros'],
        'regalar': ['juguetes', 'peluches', 'coches', 'cuentos'],
        'comprar': ['juguetes', 'coches', 'muñecas', 'pilas', 'disfraces'],
        'montar': ['trenes', 'pistas', 'puzzles', 'robots', 'aviones', 'barcos'],
        'desarmar': ['bloques', 'robots', 'pistas'],
        'elegir': ['juguetes', 'muñecas', 'juegos'],
        'contar': ['coches', 'muñecas', 'bloques', 'peluches', 'fichas', 'dados', 'canicas', 'cartas'],
        'apilar': ['bloques', 'cajas', 'libros'],
        'clasificar': ['coches', 'muñecas', 'bloques', 'colores'],
        'buscar': ['juguetes', 'piezas', 'pelotas'],
        'encontrar': ['juguetes', 'peluches', 'piezas perdidas'],
        'compartir': ['juguetes', 'juegos'],
        'lanzar': ['pelotas', 'aviones', 'dados'],
        'esconder': ['juguetes', 'tesoros'],
        'perder': ['piezas de puzzle', 'fichas', 'canicas'],
        'romper': ['juguetes', 'cajas'],
        'sacar': ['juguetes', 'juegos'],
        'girar': ['trompos'],
        'pintar': ['dibujos', 'figuras']
    },

    // 20. DEPORTE
    deporte: {
        'correr': ['kilómetros', 'jugadores', 'pistas'],
        'saltar': ['obstáculos', 'vallas', 'cuerda'],
        'lanzar': ['balones', 'pelotas', 'discos'],
        'marcar': ['goles', 'canastas', 'puntos'],
        'ganar': ['medallas', 'trofeos', 'puntos', 'partidos'],
        'perder': ['puntos', 'partidos', 'balones'],
        'empatar': ['puntos', 'partidos'],
        'entrenar': ['jugadores', 'equipos'],
        'pitar': ['árbitros', 'faltas'],
        'cronometrar': ['minutos', 'segundos'],
        'competir': ['jugadores', 'equipos'],
        'participar': ['jugadores', 'equipos', 'carreras'],
        'estirar': ['jugadores', 'músculos'],
        'beber': ['botellas de agua', 'bebidas'],
        'descansar': ['jugadores', 'suplentes'],
        'pedalear': ['kilómetros', 'bicis'],
        'nadar': ['metros', 'largos'],
        'golpear': ['balones', 'raquetas'],
        'atrapar': ['balones', 'pelotas'],
        'calentar': ['jugadores'],
        'traer': ['balones', 'equipación', 'agua'],
        'comprar': ['entradas', 'material', 'zapatillas'],
        'recibir': ['premios', 'pases'],
        'entrar': ['jugadores', 'campo'],
        'salir': ['jugadores', 'campo'],
        'quitar': ['petos', 'zapatillas'],
        'romper': ['raquetas', 'redes'],
        'fallar': ['goles', 'canastas', 'penaltis'],
        'gastar': ['energía', 'dinero']
    },

    // 21. ORDENANDO CUARTO
    ordenando_cuarto: {
        'guardar': ['camisetas', 'pantalones', 'zapatos', 'libros'],
        'recoger': ['juguetes', 'calcetines', 'zapatos'],
        'limpiar': ['estantes'],
        'doblar': ['camisetas', 'pantalones', 'sábanas'],
        'colgar': ['camisetas', 'perchas'],
        'sacudir': ['almohadas'],
        'clasificar': ['calcetines', 'zapatos'],
        'tirar': ['papeles'],
        'encontrar': ['calcetines', 'zapatos'],
        'perder': ['calcetines'],
        'organizar': ['libros', 'cuadernos'],
        'apilar': ['libros'],
        'barrer': ['suelos'],
        'estirar': ['sábanas'],
        'colocar': ['almohadas'],
        'vaciar': ['papeleras'],
        'llenar': ['cajas']
    },

    // 22. MANUALIDADES
    manualidades: {
        'cortar': ['hojas de papel', 'cartulinas'],
        'pegar': ['hojas de papel', 'pegatinas', 'botones'],
        'pintar': ['hojas de papel'],
        'dibujar': ['hojas de papel'],
        'medir': ['cintas adhesivas', 'lanas'],
        'doblar': ['hojas de papel'],
        'decorar': ['hojas de papel', 'cartulinas'],
        'diseñar': ['proyectos'],
        'crear': ['proyectos'],
        'ensartar': ['cuentas de colores'],
        'mezclar': ['témperas'],
        'recortar': ['hojas de papel'],
        'regalar': ['proyectos'],
        'barnizar': ['proyectos'],
        'modelar': ['proyectos'],
        'coser': ['telas'],
        'borrar': ['dibujos'],
        'afilar': ['lápices']
    },

    // 23. CROMOS
    cromos: {
        'coleccionar': ['cromos'],
        'cambiar': ['cromos', 'repetidos'],
        'pegar': ['cromos'],
        'comprar': ['sobres', 'cromos'],
        'abrir': ['sobres'],
        'encontrar': ['cromos', 'brillantes', 'especiales'],
        'buscar': ['cromos'],
        'completar': ['páginas del álbum'],
        'repetir': ['cromos'],
        'regalar': ['cromos', 'repetidos'],
        'guardar': ['cromos', 'álbumes'],
        'contar': ['cromos', 'repetidos'],
        'ordenar': ['cromos'],
        'mirar': ['álbumes'],
        'elegir': ['cromos'],
        'perder': ['cromos'],
        'tachar': ['listas de faltas'],
        'ofrecer': ['cromos'],
        'recibir': ['cromos']
    },

    // 24. FRUTERÍA
    fruteria: {
        'comprar': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos'],
        'pesar': ['manzanas', 'plátanos', 'peras', 'naranjas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos'],
        'elegir': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos'],
        'pagar': ['monedas', 'billetes', 'manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos'],
        'cobrar': ['euros', 'clientes'],
        'meter': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos', 'frutas en bolsas'],
        'oler': ['fresas', 'melones', 'piñas', 'melocotones', 'mangos', 'papayas', 'cocos'],
        'probar': ['uvas', 'fresas', 'cerezas', 'ciruelas', 'trozos de fruta'],
        'contar': ['manzanas', 'plátanos', 'peras', 'naranjas', 'limones', 'melocotones', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'cajas', 'cestas', 'zumos'],
        'vender': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos'],
        'limpiar': ['manzanas', 'peras', 'ciruelas', 'mostrador', 'balanzas', 'estanterías'],
        'reponer': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos', 'frutas'],
        'ofrecer': ['muestras', 'trozos de fruta', 'zumos'],
        'madurar': ['plátanos', 'peras', 'aguacates', 'mangos', 'papayas'],
        'traer': ['cajas', 'cestas', 'manzanas', 'plátanos', 'peras', 'naranjas', 'kiwis'],
        'recibir': ['cajas', 'pedidos', 'frutas'],
        'tirar': ['frutas estropeadas', 'cajas vacías', 'papeles'],
        'llevarse': ['manzanas', 'plátanos', 'peras', 'naranjas', 'fresas', 'uvas', 'sandías', 'melones', 'piñas', 'limones', 'melocotones', 'cerezas', 'kiwis', 'ciruelas', 'aguacates', 'pomelos', 'mangos', 'papayas', 'cocos', 'zumos'],
        'regalar': ['manzanas', 'plátanos', 'naranjas', 'uvas'],
        'vaciar': ['cajas', 'cestas', 'camiones'],
        'llenar': ['bolsas', 'cajas', 'cestas', 'estanterías']
    },

    // 25. SUPERMERCADO
    supermercado: {
        'llenar': ['carritos', 'cestas', 'bolsas', 'neveras', 'estantes'],
        'buscar': ['productos', 'latas', 'briks de leche', 'paquetes de galletas', 'botellas', 'yogures', 'botes de champú', 'cajas de cereales', 'tarros de mermelada', 'paquetes de arroz', 'botellas de aceite', 'paquetes de pasta', 'tabletas de chocolate', 'latas de atún', 'botes de tomate', 'huevos', 'zumos', 'quesos'],
        'comparar': ['precios', 'marcas', 'productos'],
        'pagar': ['billetes', 'monedas', 'compra'],
        'pasar': ['productos', 'compra'],
        'empujar': ['carritos'],
        'pesar': ['frutas', 'verduras', 'granel'],
        'leer': ['etiquetas', 'precios', 'ofertas'],
        'ahorrar': ['euros', 'dinero'],
        'gastar': ['euros', 'dinero'],
        'elegir': ['productos', 'yogures', 'galletas', 'frutas', 'cereales', 'quesos', 'zumos', 'chocolates'],
        'embolsar': ['productos', 'compra'],
        'cargar': ['bolsas', 'cajas', 'paquetes', 'botellas'],
        'esperar': ['clientes', 'turno'],
        'encontrar': ['productos', 'ofertas', 'gangas'],
        'escanear': ['códigos', 'productos', 'compra'],
        'cobrar': ['euros', 'clientes', 'compra'],
        'reponer': ['productos', 'estantes', 'neveras', 'leche', 'galletas', 'cereales'],
        'mirar': ['precios', 'ofertas', 'estantes'],
        'meter': ['productos', 'compra', 'monedas'],
        'comprar': ['latas', 'briks de leche', 'paquetes de galletas', 'botellas', 'yogures', 'bolsas', 'botes de champú', 'cajas de cereales', 'tarros de mermelada', 'paquetes de arroz', 'botellas de aceite', 'paquetes de pasta', 'tabletas de chocolate', 'latas de atún', 'botes de tomate', 'huevos', 'zumos', 'quesos'],
        'traer': ['carritos', 'cestas', 'bolsas'],
        'sacar': ['productos', 'cartera', 'monedas'],
        'vender': ['productos', 'comida'],
        'vaciar': ['carritos', 'cestas', 'estantes']
    },

    // 26. CENTRO COMERCIAL
    centro_comercial: {
        'mirar': ['escaparates', 'tiendas', 'ropa', 'juguetes', 'libros'],
        'probar': ['ropa', 'zapatillas', 'gorras', 'vestidos', 'pantalones', 'relojes', 'gafas de sol'],
        'caminar': ['pasillos'],
        'subir': ['escaleras mecánicas', 'ascensores', 'plantas'],
        'bajar': ['escaleras mecánicas', 'ascensores', 'plantas'],
        'comprar': ['camisetas', 'zapatillas', 'juguetes', 'libros', 'gorras', 'mochilas', 'videojuegos', 'regalos', 'vestidos', 'pantalones', 'relojes', 'perfumes', 'gafas de sol', 'juegos de mesa', 'peluches', 'balones', 'bufandas', 'cajas de lápices', 'paraguas'],
        'merendar': ['helados', 'bocadillos', 'refrescos'],
        'descansar': ['bancos', 'zonas de descanso'],
        'buscar': ['tiendas', 'baños', 'salida', 'regalos', 'ofertas'],
        'elegir': ['tiendas', 'productos', 'ropa', 'regalos'],
        'pagar': ['euros', 'entradas'],
        'entrar': ['tiendas', 'cines', 'probadores'],
        'salir': ['tiendas', 'centro comercial'],
        'aparcar': ['coches'],
        'pasear': ['familias', 'perros'],
        'encontrar': ['tiendas', 'amigos', 'ofertas'],
        'perder': ['personas', 'tickets'],
        'gastar': ['euros'],
        'ahorrar': ['euros'],
        'traer': ['bolsas', 'dinero'],
        'ganar': ['sorteos', 'premios']
    },

    // 27. BIBLIOTECA
    biblioteca: {
        'leer': ['libros', 'cuentos'],
        'prestar': ['libros'],
        'devolver': ['libros'],
        'buscar': ['libros', 'cuentos'],
        'silenciar': ['personas'],
        'escribir': ['notas'],
        'estudiar': ['libros'],
        'ordenar': ['libros'],
        'elegir': ['cuentos', 'libros'],
        'renovar': ['préstamos'],
        'sellar': ['carnets'],
        'abrir': ['libros'],
        'cerrar': ['libros'],
        'consultar': ['enciclopedias', 'diccionarios'],
        'ojear': ['revistas'],
        'registrar': ['libros'],
        'anotar': ['fichas'],
        'recomendar': ['cuentos'],
        'cuidar': ['libros']
    },

    // 28. PATIO COLEGIO
    patio_colegio: {
        'jugar': ['niños', 'niñas'],
        'saltar': ['niños', 'a la cuerda'],
        'correr': ['niños', 'niñas'],
        'compartir': ['bocadillos', 'balones'],
        'gritar': ['niños'],
        'merendar': ['bocadillos'],
        'formar': ['equipos', 'filas'],
        'entrar': ['niños', 'al colegio'],
        'salir': ['niños', 'del colegio'],
        'perseguir': ['niños'],
        'esconderse': ['niños'],
        'lanzar': ['balones'],
        'charlar': ['niños', 'amigos'],
        'arbitrar': ['profesores'],
        'marcar': ['goles'],
        'buscar': ['amigos'],
        'encontrar': ['pelotas']
    },

    // 29. MUSEO
    museo: {
        'observar': ['fósiles', 'esqueletos', 'minerales'],
        'descubrir': ['fósiles'],
        'aprender': ['visitantes'],
        'guiar': ['guías'],
        'dibujar': ['fósiles', 'esqueletos'],
        'fotografiar': ['réplicas'],
        'investigar': ['científicos'],
        'explicar': ['guías'],
        'mirar': ['vitrinas', 'maquetas'],
        'caminar': ['salas'],
        'asombrarse': ['visitantes'],
        'leer': ['carteles'],
        'comparar': ['fósiles', 'esqueletos'],
        'contar': ['fósiles', 'huesos'],
        'clasificar': ['minerales'],
        'exponer': ['réplicas'],
        'encontrar': ['fósiles'],
        'medir': ['huesos'],
        'proteger': ['fósiles']
    },

    // 30. BOMBEROS
    bomberos: {
        'apagar': ['incendios'],
        'rescatar': ['personas', 'animales'],
        'entrenar': ['bomberos'],
        'subir': ['escaleras'],
        'bajar': ['escaleras'],
        'conducir': ['camiones'],
        'sonar': ['sirenas'],
        'limpiar': ['camiones', 'mangueras'],
        'revisar': ['extintores', 'equipos'],
        'ayudar': ['personas'],
        'deslizar': ['barras'],
        'avisar': ['emergencias'],
        'proteger': ['personas'],
        'equipar': ['bomberos'],
        'vigilar': ['edificios'],
        'responder': ['llamadas'],
        'cargar': ['mangueras'],
        'escalar': ['edificios'],
        'salvar': ['personas']
    },

    // 31. HOSPITAL
    hospital: {
        'curar': ['pacientes'],
        'cuidar': ['pacientes'],
        'visitar': ['pacientes', 'familiares'],
        'nacer': ['bebés'],
        'operar': ['médicos'],
        'pesar': ['pacientes'],
        'medir': ['temperaturas'],
        'recetar': ['medicinas'],
        'ayudar': ['enfermeros'],
        'llamar': ['médicos'],
        'descansar': ['pacientes'],
        'caminar': ['pacientes'],
        'vendar': ['heridas'],
        'inyectar': ['sueros'],
        'mejorar': ['pacientes'],
        'auscultar': ['pacientes'],
        'avisar': ['familiares'],
        'sanar': ['pacientes'],
        'atender': ['pacientes']
    },

    // 32. CASTILLO
    castillo: {
        'defender': ['caballeros', 'torres'],
        'atacar': ['enemigos'],
        'subir': ['torres', 'escaleras'],
        'vigilar': ['caballeros'],
        'coronar': ['reyes', 'reinas'],
        'cabalgar': ['caballos'],
        'disparar': ['flechas'],
        'bajar': ['puentes levadizos'],
        'cerrar': ['puertas'],
        'abrir': ['puertas'],
        'explorar': ['salas'],
        'asomarse': ['almenas'],
        'reinar': ['reyes'],
        'vivir': ['reyes', 'reinas'],
        'luchar': ['caballeros'],
        'proteger': ['castillos'],
        'construir': ['murallas'],
        'sonar': ['trompetas'],
        'celebrar': ['fiestas'],
        'esconder': ['tesoros']
    }
};

// Exportar al window
if (typeof window !== 'undefined') {
    window.SEMANTIC_MAPPINGS = SEMANTIC_MAPPINGS;
}

console.log('✅ [SemanticMappings] Mapeos semánticos cargados para 32 contextos');
